import { getMetricKind, MetricKind } from '@gonfalon/metrics/MetricKind';
import type { Metric } from '@gonfalon/metrics/types';

const UNIT_FALLBACK_KINDS = new Set<string>([MetricKind.COUNT, MetricKind.COUNT_DISTINCT, MetricKind.NUMERIC]);

/**
 * Resolves the display unit for a metric. Count, count distinct, and numeric
 * metrics without an explicit unit default to "units". Binary metrics return undefined so that
 * {@link formatDifferenceValue} can apply the appropriate scaling and "pp" label.
 */
export function resolveMetricUnit(
  metric: Pick<Metric, 'unit' | 'kind' | 'unitAggregationType' | 'isNumeric'>,
): string | undefined {
  if (metric.unit?.trim()) {
    return metric.unit;
  }

  const kind = getMetricKind(metric.kind, metric.unitAggregationType, metric.isNumeric);
  return UNIT_FALLBACK_KINDS.has(kind) ? 'units' : undefined;
}
